import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::continueMethod
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:29
* @route '/auth/login/apple/callback/continue'
*/
export const continueMethod = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: continueMethod.url(options),
    method: 'post',
})

continueMethod.definition = {
    methods: ["post"],
    url: '/auth/login/apple/callback/continue',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::continueMethod
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:29
* @route '/auth/login/apple/callback/continue'
*/
continueMethod.url = (options?: RouteQueryOptions) => {
    return continueMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::continueMethod
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:29
* @route '/auth/login/apple/callback/continue'
*/
continueMethod.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: continueMethod.url(options),
    method: 'post',
})

const callback = {
    continue: Object.assign(continueMethod, continueMethod),
}

export default callback